import { flutterReady } from '@/flutter'

export async function handleLaunchBrowser(url: string) {
  // call `openURL` flutter handler
  await flutterReady
  await window.flutter_inappwebview.callHandler('openURL', { url: url })
}
